import { createSvgIcon } from '@automata/mui-theme';
export const PlaceholderIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.9999 19.4641L23.2871 33.732V62.2679L47.9999 76.5359L72.7127 62.2679V33.732L47.9999 19.4641ZM75.7127 32L47.9999 16L20.2871 32V64L47.9999 80L75.7127 64V32Z"
    />
  </svg>,
  'PlaceholderIcon'
);
